import { render, staticRenderFns } from "./CreatedBy.vue?vue&type=template&id=6073f276&scoped=true&"
import script from "./CreatedBy.vue?vue&type=script&lang=ts&"
export * from "./CreatedBy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6073f276",
  null
  
)

export default component.exports